import { RouteConfig } from "vue-router";
import { safeImport } from "@/utils/SafeImport";

const routes: Array<RouteConfig> = [
  {
    path: "/tasks",
    name: "tasks",
    component: safeImport(
      () => import(/* webpackChunkName: "route.tasks" */ "../views/Tasks.vue")
    ),
    meta: {
      auth: true,
    },
  },
];

export default routes;
